module.exports = __webpack_public_path__ + "img/symbol_5.363a732a.png";